export default __webpack_public_path__ + "../images/favicon-194x194.png";